// extracted by mini-css-extract-plugin
module.exports = {"form":"src-_components-___FrequentAddressEditForm-module__form___2Q6_8"};